module.exports = __webpack_public_path__ + "img/inactive-18.69fd8823.svg";